<template>
  <div class="multiselect__main">
    <Multiselect
      v-model="selectedOption"
      :options="normalizedOptions"
      :multiple="false"
      :close-on-select="true"
      :placeholder="placeholder"
      :preselect-first="true"
      :allow-empty="false"
      :label="label"
      track-by="value"
      tag-placeholder="Добавить"
      select-label=""
      deselect-label=""
      selected-label=""
      deselect-group-label=""
    >
      <template #noResult>
        Ничего не найдено
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "CustomMultiselect",
  components: { Multiselect },
  emits: ['on-edit-profile'],
  props: {
    options: { type: Array, required: true },
    placeholder: { type: String, default: '' },
    modelValue: { required: false },
    label: { type: String, default: 'label' },
  },
  computed: {
    normalizedOptions() {
      return (this.options || []).map(opt => {
        // простые значения (string, number, boolean, null, undefined)
        if (opt === null || typeof opt !== 'object') {
          return { label: String(opt ?? ''), value: opt }
        }

        // объект -- вычисляем label/value независимо от того, присутствуют ли ключи
        const hasLabel = Object.prototype.hasOwnProperty.call(opt, 'label')
        const hasValue = Object.prototype.hasOwnProperty.call(opt, 'value')

        const value = hasValue ? opt.value : (hasLabel ? opt.label : opt)
        const label = hasLabel ? String(opt.label) : String(hasValue ? opt.value : opt)

        // сохраняем все остальные свойства объекта, но гарантируем корректные label/value
        return { ...opt, label, value }
      })
    },

    selectedOption: {
      get() {
        return this.normalizedOptions.find(opt => opt.value === this.modelValue) || null
      },
      set(val) {
        this.$emit('update:modelValue', val?.value ?? null)
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

.multiselect {
  min-height: 2rem !important;
  max-height: 2rem !important;
}
.multiselect__main {
  width: 100%;
}
.multiselect__main * {
  
}
.multiselect, .multiselect__single {
  color: var(--color-0);
  background: transparent !important;
  border-size: 0 !important;
  border-radius: 0.5rem;
  margin: 0 !important; 
}
.navbar-left .multiselect, .multiselect__single {
  color: #808080;
}
.navbar-left {
}
  .multiselect__single {
    margin-bottom: 0;
    font-weight: bold;
    line-height: 1.2rem !important;
  }
  .multiselect__content-wrapper {
    padding: 0;
  }
  .multiselect__select {
    z-index: 10 !important;
    width: 2rem !important;
    height: 2rem !important;
    padding: 0 !important;
    top: 0rem !important;
  }
  .multiselect__tags {
    width: 8.4rem;
    border-top-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 0px;
    border-left-width: 0px;
    background: var(--grey-1) !important;
    padding: 0.3rem;
    border-radius: 0.4rem;
    display: flex;
    align-items: center;
    min-height: 2rem;
    display: block;
    padding: 0.5rem 2rem 0 0.5rem;
    border-radius: 0.5rem;
    border: 1px solid #e8e8e8;
    font-size: 1rem !important;
    max-height: 2rem !important;
    padding: 0.3rem 2rem 0rem 0.5rem !important;
    min-height: 2rem !important;
    border: none !important;
  }
  .navbar-left .multiselect__tags {
    width: 6.4rem;
  }

@media(max-width: 768px) {
  .multiselect__tags {
    width: 7.5rem;
  } 
}
.multiselect__input {
  padding: 0rem !important;
  border: 0 !important;
  background: var(--grey-1) !important ;
  color: white !important;
  outline: none !important;
  margin-bottom: 1rem !important;
}
.multiselect__input:focus {
  outline: none !important;
  padding: 0 0 0 5px !important;
}
.multiselect__input:active, .multiselect__input:hover, .multiselect__input:focus {
    outline: 0;
    border: none;
    outline-offset: 0;
}
.multiselect__input::placeholder, .multiselect__placeholder {
  color: var(--color-0) !important;
  font-size: 1rem;
  /*padding-left: 0.3rem;
  transform: translateY(.15rem);*/
  margin-bottom: 0;
}
.multiselect__tag {
  background: var(--grey-1);
  color: var(--color-0);
  position: relative;
  display: inline-block;
  padding: 0.3rem 1.5rem 0.3rem 0.5rem;
  border-radius: 0.3rem;
  margin-right: 0.4rem;
  line-height: 1;
  margin-bottom: 0.4rem;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  transition: 0.3s ease all;
}
.multiselect__tag:hover {
  background: var(--grey-2)
}
.multiselect__tag-icon::after {
  color: var(--color-0);
  margin-left: -0.3rem;
}
.multiselect__content-wrapper {
  background: var(--grey-0) !important;
  color: white !important;
  border: 0 !important;
}
.multiselect__option {
  transition: 0.3s ease all;
  span {
    transition: 0.3s ease all;
  }
}
.multiselect__option:hover {
  background: var(--grey-0) !important;
  color: white !important;
  border: 0 !important;
  span {
    background: var(--grey-0) !important;
  }
}
.multiselect__element span {
  background: var(--grey-1) !important;
  color: white !important;
}
.multiselect__element:hover {
  background: var(--grey-3) !important ;
}
.multiselect__content *:hover {
  color: red
}
</style>
<div class="multiselect__content-wrapper" tabindex="-1" style="max-height: 300px;">
    <ul class="multiselect__content" role="listbox" id="listbox-null" aria-multiselectable="false" style="display: inline-block;">
        <!--v-if-->
        <li class="multiselect__element" aria-selected="false" id="null-0" role="option"><span class="multiselect__option--highlight multiselect__option" data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove"><span>list</span></span>
            <!--v-if-->
        </li>
        <li class="multiselect__element" aria-selected="false" id="null-1" role="option"><span class="multiselect__option" data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove"><span>of</span></span>
            <!--v-if-->
        </li>
        <li class="multiselect__element" aria-selected="false" id="null-2" role="option"><span class="multiselect__option" data-select="Press enter to select" data-selected="Selected" data-deselect="Press enter to remove"><span>options</span></span>
            <!--v-if-->
        </li>
        <li style="display: none;"><span class="multiselect__option">No elements found. Consider changing the search query.</span></li>
        <li style="display: none;"><span class="multiselect__option">List is empty.</span></li>
    </ul>
</div>

